<template>
    <div>
        <el-input
            :placeholder="placeholder"
            :size="size"
            :readonly="isReadonly"
            :disabled="stateDisabled"
            style="line-hight: 40px"
            @blur="changeVal"
            v-model="name"
            class="input-with-select"
            width="60%"
        >
            <el-button slot="append" :disabled="stateDisabled" @click="showSelectDialog" icon="el-icon-search"></el-button>
        </el-input>
        <el-dialog :title="title" :close-on-click-modal="false" :append-to-body="true" v-dialogDrag :visible.sync="visible" width="800px">
            <el-row :gutter="15">
                <el-col :span="18">
                    <el-form :inline="true" ref="searchForm" class="" @keyup.enter.native="refreshList()" @submit.native.prevent>
                        <el-form-item v-for="(search, index) in searchs" :key="index" :prop="search.prop">
                            <el-input size="small" v-model="searchForms[index]" :placeholder="search.label" clearable></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="refreshList()" size="small">查询</el-button>
                            <el-button @click="resetSearch()" size="small">重置</el-button>
                        </el-form-item>
                    </el-form>
                    <el-table
                        :data="dataList"
                        v-loading="loading"
                        border
                        size="small"
                        ref="userTable"
                        @selection-change="selectionChangeHandle"
                        @sort-change="sortChangeHandle"
                        style="width: 100%"
                    >
                        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
                        <template>
                            <el-table-column
                                v-for="(column, index) in columns"
                                :key="index"
                                :prop="column.prop"
                                header-align="center"
                                align="center"
                                min-width="100px"
                                :label="column.label"
                                v-if="column.img == 'img'"
                            >
                                <template slot-scope="scope">
                                    <img class="i1" v-if="column.prop == 'logo'" :src="scope.row.logo" alt="品牌logo"/>
                                    <div v-else>{{ scope.row.fullName }}</div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                v-else
                                v-for="(column, index) in columns"
                                :key="index"
                                :prop="column.prop"
                                header-align="center"
                                align="center"
                                min-width="100px"
                                :label="column.label"
                            >
                            </el-table-column>
                        </template>
                    </el-table>
                    <el-pagination
                        @size-change="sizeChangeHandle"
                        @current-change="currentChangeHandle"
                        :current-page="pageNo"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pageSize"
                        :total="total"
                        layout="total, sizes, prev, pager, next, jumper"
                    ></el-pagination>
                </el-col>
                <el-col :span="6">
                    <el-tag :key="tag.id" v-for="tag in dataListAllSelections" closable :disable-transitions="false" @close="del(tag)">{{
                        tag[labelName]
                    }}</el-tag>
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible = false">关闭</el-button>
                <el-button type="primary" @click="doSubmit()">确定</el-button>
            </span>
            <!-- <ConsultRecord :queryForm="queryForm" :checkState="checkState" @resetCheckState="resetCheckState"></ConsultRecord> -->
        </el-dialog>
    </div>
</template>

<script>
import { get } from '@/utils/request.js';
import { getUserById } from '@/api/user.js';
//import DictTypeListTable from '@/components/system/DictTypeListTable.vue';
export default {
    data() {
        return {
            searchForms: [],
            filterText: '',
            dataListAllSelections: [], // 所有选中的数据包含跨页数据
            dataListSelections: [],
            idKey: 'id', // 标识列表数据中每一行的唯一键的名称(需要按自己的数据改一下)
            dataList: [],
            dynamicTags: [],
            selectData: [],
            pageNo: 1,
            pageSize: 10,
            total: 0,
            loading: false,
            visible: false,
            name: '',
            relatedFee: '',
            enname: ''
        };
    },
    props: {
        limit: {
            type: Number,
            default: 1
        },
        stateDisabled: {
            type: Boolean,
            default: false
        },
        columns: {
            type: Array,
            default: () => {
                return [];
            }
        },

        searchs: {
            type: Array,
            default: () => {
                return [];
            }
        },
        dataListUrl: {
            type: String,
            default: () => {
                return null;
            }
        },
        queryEntityUrl: {
            type: String,
            default: () => {
                return null;
            }
        },
        entityBeanName: {
            type: String,
            default: () => {
                return null;
            }
        },
        value: {
            type: String,
            default: () => {
                return '';
            }
        },
        title: {
            type: String,
            default: () => {
                return '';
            }
        },
        labelName: {
            type: String,
            default: () => {
                return '';
            }
        },
        labelValue: {
            type: String,
            default: () => {
                return '';
            }
        },
        size: {
            type: String,
            default: () => {
                return 'default';
            }
        },
        goodsCategoryName: {
            type: String,
            default: () => {
                return '';
            }
        },
        isReadonly: {
            type: Boolean,
            default: true
        },
        ParentComponentName: {
            type: String,
            default: () => {
                return '';
            }
        },
        userName: {
            type: String,
            default: () => {
                return '';
            }
        },
        placeholder: {
            type: String,
            default: '请选择'
        },
        token: {
            type: String,
            default: localStorage.getItem('token')
        }
    },
    watch: {
        value: {
            handler(newVal) {
                this.selectData = [];
                if (newVal) {
                    newVal.split(',').forEach((value) => {
                        if (value) {
                            get(this.queryEntityUrl, { id: value }).then((data) => {

                                // 解决俩次才能选上问题
                                if(data.success){
                                    for (let i = 0; i < data.brand.data.length; i++) {
                                        if(data.brand.data[i].id == value){
                                            this.selectData.push(data.brand.data[i]);
                                        }
                                    }
                                }

                                // 修改前的代码
                                // console.log('data[this.entityBeanName][this.labelValue]'+data.mppUser);
                                // if (data[this.entityBeanName][this.labelValue] !== '') {
                                //     this.selectData.push(data[this.entityBeanName]);
                                // }
                            });
                            // getUserById({id: value}).then(())
                        }
                    });
                }
            },
            immediate: true,
            deep: false
        },
        userName: {
            handler(newVal) {
                if (newVal) {
                    this.name = newVal;
                }
            }
        },
        selectData: {
            handler(newVal) {
                this.dataListAllSelections = JSON.parse(JSON.stringify(this.selectData));
                this.name = this.dataListAllSelections
                    .map((item) => {
                        return item[this.labelName];
                    })
                    .join(',');
            },
            immediate: false,
            deep: false
        }
    },
    methods: {
        init() {
            this.visible = true;
            this.$nextTick(() => {
                this.resetSearch();
            });
        },
        // 设置选中的方法
        setSelectRow() {
            if (!this.dataListAllSelections || this.dataListAllSelections.length <= 0) {
                this.$refs.userTable.clearSelection();
                return;
            }
            // 标识当前行的唯一键的名称
            let idKey = this.idKey;
            let selectAllIds = [];
            this.dataListAllSelections.forEach((row) => {
                selectAllIds.push(row[idKey]);
            });
            this.$refs.userTable.clearSelection();
            for (var i = 0; i < this.dataList.length; i++) {
                if (selectAllIds.indexOf(this.dataList[i][idKey]) >= 0) {
                    // 设置选中，记住table组件需要使用ref="table"
                    this.$refs.userTable.toggleRowSelection(this.dataList[i], true);
                }
            }
        },
        // 记忆选择核心方法
        changePageCoreRecordData() {
            // 标识当前行的唯一键的名称
            let idKey = this.idKey;
            let that = this;
            // 如果总记忆中还没有选择的数据，那么就直接取当前页选中的数据，不需要后面一系列计算
            if (this.dataListAllSelections.length <= 0) {
                this.dataListSelections.forEach((row) => {
                    that.dataListAllSelections.push(row);
                });
                return;
            }
            // 总选择里面的key集合
            let selectAllIds = [];
            this.dataListAllSelections.forEach((row) => {
                selectAllIds.push(row[idKey]);
            });
            let selectIds = [];
            // 获取当前页选中的id
            this.dataListSelections.forEach((row) => {
                selectIds.push(row[idKey]);
                // 如果总选择里面不包含当前页选中的数据，那么就加入到总选择集合里
                if (selectAllIds.indexOf(row[idKey]) < 0) {
                    that.dataListAllSelections.push(row);
                }
            });
            let noSelectIds = [];
            // 得到当前页没有选中的id
            this.dataList.forEach((row) => {
                if (selectIds.indexOf(row[idKey]) < 0) {
                    noSelectIds.push(row[idKey]);
                }
            });
            noSelectIds.forEach((id) => {
                if (selectAllIds.indexOf(id) >= 0) {
                    for (let i = 0; i < that.dataListAllSelections.length; i++) {
                        if (that.dataListAllSelections[i][idKey] === id) {
                            // 如果总选择中有未被选中的，那么就删除这条
                            that.dataListAllSelections.splice(i, 1);
                            break;
                        }
                    }
                }
            });
        },
        // 得到选中的所有数据
        getAllSelectionData() {
            // 再执行一次记忆勾选数据匹配，目的是为了在当前页操作勾选后直接获取选中数据
            this.changePageCoreRecordData();
        },
        filterNode(value, data) {
            if (!value) return true;
            return data.name.indexOf(value) !== -1;
        },
        del(tag) {
            this.dataListAllSelections.splice(this.dataListAllSelections.indexOf(tag), 1);
            this.$nextTick(() => {
                this.setSelectRow();
            });
        },
        // 获取数据列表
        refreshList() {
            this.loading = true;
            let searchForm = {};
            this.searchs.forEach((search, index) => {
                searchForm[search.prop] = this.searchForms[index];
            });

            get(this.dataListUrl, { ...searchForm, pageNum: this.pageNo, pageSize: this.pageSize }).then((res) => {
                if (res.success) {
                    this.dataList = res.brand.data;
                    this.total = res.brand.total;
                    this.loading = false;
                }
            });
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageNo = 1;
            this.refreshList();
            this.$nextTick(() => {
                this.changePageCoreRecordData();
            });
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageNo = val;
            this.refreshList();
            this.$nextTick(() => {
                this.changePageCoreRecordData();
            });
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val;
            this.$nextTick(() => {
                this.changePageCoreRecordData();
            });
        },
        // 排序
        sortChangeHandle(obj) {
            if (obj.order === 'ascending') {
                this.orderBy = obj.prop + ' asc';
            } else if (obj.order === 'descending') {
                this.orderBy = obj.prop + ' desc';
            } else {
                this.orderBy = '';
            }
            this.refreshList();
        },
        resetSearch() {
            this.$refs.searchForm.resetFields();
            this.searchForms = [];
            this.refreshList();
        },
        doSubmit() {
            if (this.limit < this.dataListAllSelections.length) {
                this.$message.error(`你最多只能选择${this.limit}条数据`);
                return;
            }
            this.visible = false;
            // 跨页多选有问题的代码
            // this.name = this.dataListSelections
            //   .map((item) => {
            //     return item[this.labelName];
            //   })
            //   .join(",");
            // let value = this.dataListSelections
            //   .map((item) => {
            //     return item[this.labelValue];
            //   })
            //   .join(",");

            //跨页多选修改后的代码
            this.name = this.dataListAllSelections
                .map((item) => {
                    return item[this.labelName];
                })
                .join(',');
            let value = this.dataListAllSelections
                .map((item) => {
                    return item[this.labelValue];
                })
                .join(',');
            // if (this.ParentComponentName == 'RpsRepairListForm' && this.limit == 1) {
            //     let params = {
            //         id: this.dataListSelections[0].id,
            //         categoryId: this.dataListSelections[0].rpsCategory.id,
            //         rpsStationId: this.dataListSelections[0].rpsStation.id,
            //         equipmentInfo: this.dataListSelections[0]
            //     };
            //     this.$http.get(`${this.queryEntityUrl}?id=${params.id}`).then(({ data }) => {
            //         if (data.success) {
            //             params.officeId = data.rpsEquipment.office.id;
            //             params.officeName = data.rpsEquipment.office.name;
            //             this.$emit('getValue', params);
            //         }
            //     });
            // } else if (this.ParentComponentName == 'RpsStationForm') {
            //     this.$emit('getValue', JSON.parse(JSON.stringify(this.dataListSelections)));
            // } else {
            //     this.$emit('getValue', value, this.name);
            // }
            if (this.limit == 1) {
                this.$emit('getValue', value, this.name);
            }
        },
        showSelectDialog() {
            this.visible = true;
            this.init();
        },
        changeVal(e) {
            if (this.ParentComponentName == 'goodsBuyChildForm') {
                this.$emit('getName', e.target.value);
            }
        }
    }
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  button{
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.i1 {
    width: 50px;
    height: 50px;
    display: block;
    margin-left: 50%;
    transform: translate(-50%, 0);
}
</style>
